
import React from 'react'
import { Grid, makeStyles,  } from '@material-ui/core';

export default function Paper(props) {
    const { children, style, className:paperClass } = props;
    const classes = useStyles({...props})()
    return(
        <Grid className={`${classes.paper} ${paperClass}`} style={style} container direction="column" alignItems="center" justify="center" >{children}</Grid>
    )
}


const useStyles = ({...props}) => makeStyles((theme) => ({
    paper:{
        boxSizing: "border-box",
        borderRadius: "45px 45px 0 0",
        display:"block",
        boxShadow:"0px -5px 7px rgba(198, 198, 198, 0.25)",
        [theme.breakpoints.up("md")]:{
            boxShadow: "unset"
        },
       '& > div':{
            padding:0,
            [theme.breakpoints.down('md')]:{
                padding:"20px 12px",
                paddingBottom:0
            }
       }
    },
}));